import { Box } from '@cmpsr/components';
import React from 'react';

/**
 * Renders the progress bar.
 */
interface CustomProgressBarProps {
  progress: number;
  progressBarColor?: string;
  progressBarBackgroundColor?: string;
  'data-testid'?: string;
}

const CustomProgressBar: React.FC<CustomProgressBarProps> = ({
  progress,
  progressBarColor,
  progressBarBackgroundColor,
  'data-testid': dataTestId,
}) => {
  return (
    <Box width="100%" data-testid={dataTestId}>
      {/* Container with background color */}
      <Box
        width="100%"
        height="6px" // xs size
        backgroundColor={progressBarBackgroundColor || 'med-blue'}
        borderRadius="md"
        position="relative"
        overflow="hidden"
        role="progressbar"
        aria-valuenow={progress}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        {/* Progress indicator with gradient */}
        <Box
          height="100%"
          width={`${progress}%`}
          background={progressBarColor || 'gradient.progress'}
          borderRadius="md"
          position="absolute"
          top="0"
          left="0"
          transition="width 0.3s ease-out"
        />
      </Box>
    </Box>
  );
};

export default CustomProgressBar;
